// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__12VwT","Label":"Checkbox_Label__2VTMM","InputElement":"Checkbox_InputElement__3yZOn","Invalid":"Checkbox_Invalid__5-ib4"};